export default "__VITE_ASSET__BBnyZkHK__"